import { FieldHtmlNameUtil } from 'www-shared';
import ExternalUtil from '../../../../../ExternalUtil';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractCheckErrorSignupScreen from './AbstractCheckErrorSignupScreen';

export default class EmailCheck204SignupScreen extends AbstractCheckErrorSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-email-check-204';

  public predicate(): boolean {
    const { emailCheckCode } = this.sessionInfo.value;
    if (emailCheckCode !== 204) {
      return false;
    }
    return true;
  }

  public async initListeners({
    partialDiv,
  }: {
    partialDiv: HTMLElement
  }): Promise<void> {
    if (this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.buyStandard)) {
      partialDiv.classList.add('d-none');
      ExternalUtil.redirectTo({ delay: 0, target: this.getField(FieldHtmlNameUtil.signupRedirectUrl).val as string });
      return;
    }

    let toShow;
    let toHide;

    if (this.sessionInfo.value.emailCheckErrorReason === 'geo-blocked') {
      partialDiv.querySelectorAll('.error-box').forEach((elm) => elm.classList.add('d-none'));
      toShow = partialDiv.querySelector('[hekate-data=geo-blocked-msg]');
      if (!toShow) {
        return;
      }
      toHide = partialDiv.querySelectorAll('[hekate-data=default-204]');
    } else {
      toShow = partialDiv.querySelector('[hekate-data=default-204]');
      if (!toShow) {
        return;
      }
      toHide = partialDiv.querySelectorAll('[hekate-data=geo-blocked-msg]');
    }

    toHide.forEach((elm) => {
      elm.classList.add('d-none');
    });
    toShow.classList.remove('d-none');
  }
}
